import { RequestPriority, Classification, ItemSearch } from '../../../shared/model/itemselectionresponse';
import { CustomField } from '../../../shared/model/customfieldsresponse';
import { CustomFieldRequest } from '../../reportincident/model/reportincident.response';
import { ItemInfoList } from '../../../store/model/storeitemdetailresponse';

export class QuickCallResponse {
    resultCount: number;
    results?: (QuickCallBasicInfo)[] | null;
}

export class QuickCallBasicInfo {
    quickCallId: number;
    name: string;
    priority: string;
    quickCallType: string;
    classification: string;
    priorityWeightage: number;
    typeKey: string;
    description: string;
    itemsInfo: (ItemInfoList)[] | null;
}

export class QuickCallDetailInfo {
    id: number;
    quickCallType: string;
    itemSpecified: boolean;
    subject: string;
    orderIndex: number;
    groupComponentsSelection: boolean;
    name: string;
    description: string;
    quickCallList?: QuickCallDetailInfo[] | null;
    priority: RequestPriority;
    classification: Classification;
    customFieldInfo ?: CustomField[] | null;
    itemInfo: ItemSearch;
    isMandatoryCustomField: boolean;
    containCustom: boolean;
    selected: boolean;
    isQuickcallFormValid: boolean;
    containCustomForm: boolean;
    formSchema: string;
    parsedFormData: any;
    requestProcess: string;
 }

export class GroupTemplateReqParameters {
    requestDescription: string;
    groupTemplateCustomFields ?: (CustomFieldRequest)[] | null;
    groupTemplateQuickCalls ?: (GroupTemplateQuickCallInfos)[] | null;
}

export class GroupTemplateQuickCallInfos {
    quickCallId: number;
    quickCallCustomFields ?: (CustomFieldRequest)[] | null;
    formData: string;
}
